import { render, staticRenderFns } from "./SwitchOrdersDetails.vue?vue&type=template&id=bf345380&scoped=true"
import script from "./SwitchOrdersDetails.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersDetails.vue?vue&type=style&index=0&id=bf345380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf345380",
  null
  
)

export default component.exports